export default {
	// Custom Page Meta
  seo_meta_title_leaguepass: 'NBA | NBA 影片與賽事精華',
	seo_meta_desc_leaguepass: 'NBA 影片包括 NBA 影片與賽事精華',
	seo_meta_keywords_leaguepass: 'NBA 影片, NBA 精華片段, 籃球影片, 精彩好球, 灌籃, 呈獻',
	seo_meta_title_featured: 'NBA | 精選',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | NBA TV Live',
	seo_meta_desc_nbatv: 'NBA TV Live 是您全天無休的 NBA TV 頻道，每周皆有現場直播及錄影轉播 NBA 賽事可供觀看，另外還提供攝影棚節目與球評分析',
	seo_meta_keywords_nbatv: 'NBA TV 頻道, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, 攝影棚節目, the jump',
	seo_meta_title_classicgames: 'NBA | 經典賽事',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | 影片清單',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | NBA TV 節目',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'NBA 首頁',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | 頻道',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | 頻道',
	seo_meta_pre_title_categories: 'NBA | 類別',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | 類別',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | 影片',
	seo_meta_pre_title_event: 'NBA | 活動',
	seo_meta_title_events: 'NBA | 活動',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | 活動：{0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | 搜尋',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | 網頁不存在',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'NBA 比賽：',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | NBA 影片與賽事精華',
	seo_meta_desc_video: 'NBA 影片包括 NBA 影片與賽事精華',
	seo_meta_keywords_video: 'NBA 影片, NBA 精華片段, 籃球影片, 精彩好球, 灌籃, 呈獻',
	seo_meta_title_channel: 'NBA | NBA TV Live',
	seo_meta_desc_channel: 'NBA TV Live 是您全天無休的 NBA TV 頻道，每周皆有現場直播及錄影轉播 NBA 賽事可供觀看，另外還提供攝影棚節目與球評分析',
	seo_meta_keywords_channel: 'NBA TV 頻道, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, 攝影棚節目, the jump',
	seo_meta_title_tvguide: 'NBA | NBA TV 賽程',
	seo_meta_desc_tvguide: 'NBA TV Live 是您全天無休的 NBA TV 頻道，每周皆有現場直播及錄影轉播 NBA 賽事可供觀看，另外還提供攝影棚節目與球評分析',
	seo_meta_keywords_tvguide: 'NBA TV 頻道, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, 攝影棚節目, the jump',

	// Common
	timezone: 'ET',
	default_feed_error_message: '系統發生問題，目前無法提供相關內容。請稍後再試一次。',
	watch_in_app: '在 NBA 應用程式上觀看',

	// Item
	no_content: '無任何內容',
	see_more: '查看更多',
	now_playing: '現正播放',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: '您的最愛影片數量已達到上限，若要加入更多影片，請先移除部分最愛影片。',
	item_live: '現場直播',
	add_favourite_title: '加到我的最愛',
	remove_favourite_title: '從我的最愛移除',
	// Channel: Schedule
	p_channel_live: '現場直播',
	p_channel_schedule_title: 'NBA TV 賽程',
	p_channel_schedule_watch: '觀看',
	p_channel_schedule_no_date: '目前沒有適用的賽程日期。',
	p_channel_live24x7_title: 'NBA TV 全年無休',
	p_channel_live24x7_see_full_schedule: '查看完整的賽程',
	p_channel_live24x7_up_next: '緊接在後',
	p_channel_live24x7_on_demand: 'NBA TV：隨選內容',
	p_channel_live24x7_collection: '集錦',
	p_channel_live24x7_demand_1_logo_text: '原創節目',
	p_channel_live24x7_demand_1_show_name: 'NBA TV 節目',
	p_channel_live24x7_demand_1_show_desc: '原創 NBA TV 節目，包括《俠客的五大好糗》、《Beyond the Paint》、《Game Time》和《籃球故事》',
	p_channel_live24x7_demand_2_logo_text: '經典賽事',
	p_channel_live24x7_demand_2_show_name: 'NBA | 經典賽事',
	p_channel_live24x7_demand_2_show_desc: '觀看整場經典賽事，包括自 2000 年以來所有總決賽大對決、精彩萬分的聯盟時刻，以及傳奇性球員英姿',
	p_channel_clips_title: 'NBA TV 短片',
	// Channel: Clips
	p_channel_error_msg: 'Not available yet',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: '賽程',

	// NBA TV Shows:
	p_nba_tv_shows: 'NBA TV 節目',
	p_nba_tv_no_access_title: '全年無休的 NBA：隨時掌握賽事分析、工作室剖析、原創節目等精彩內容！',
	p_nba_tv_no_access_desc: '觀看直播賽事，並隨選點播其他節目和經典賽事。',
	p_nba_tv_no_access_note: '可能會有播出限制',

	// tv show item
	tv_show_item_latest_episode: '最新一集',
	tv_show_item_no_latest_episode: '沒有最新集數',
	see_all: '查看全部',
	// header
	header_menu_watch: '觀看',
	header_menu_featured: '精選',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// Search
	players: '球員',
	videos: '影片',
	teams: '球隊',
	most_searched: '熱門搜尋',
	no_result: '無任何資料',
	search_filter_type_most_relevant: '最相關',
	search_filter_type_most_viewed: '最多人觀賞',
	search_filter_type_most_recent: '最近期',
	search_filter_type_last_30_days: '過去 30 天',
	search_filter_type_last_6_months: '過去 6 個月',
	search_result_label: '「{keyword}」的搜尋結果',
	search_result_info: '查看所有「{keyword}」的搜尋結果',
	search_placeholder: '搜尋影片庫',
	load_more: '載入更多...',

	// button
	button_subscribe: '訂閱',
	button_sign_in: '登入',

	// league page
	p_league_pass_no_access_title: '透過任何裝置觀看直播賽事或重播比賽，想用電腦、智慧型手機或電視觀賽都沒問題！',
	p_league_pass_no_access_desc: '取得精彩賽事入場券：觀看整個聯盟或愛隊的英姿、選看單場比賽，或查看其他更多選項。',
	p_league_pass_no_access_note: '適用相關條款',

	// Video
	category_title: '影片',
	p_video_playlist_title: '播放清單：',
	p_no_access_league_pass_title: '解鎖 NBA League Pass 以觀看：',
	p_no_access_league_pass_desc: '取得精彩賽事入場券：觀看整個聯盟或愛隊的英姿、選看單場比賽，或查看其他更多選項。',
	p_no_access_league_pass_terms: '適用相關條款',
	p_no_access_league_pass_geo_desc: '根據您目前的位置，您無法透過 NBA League Pass 和 NBA TV 觀看這場比賽。錄影賽事影片將在轉播後的 3 天，供 NBA League Pass 訂戶觀看。請洽詢您當地的電視或廣電業者，確認賽事播放的時間表。',
	p_no_access_league_pass_not_found_desc: '抱歉，找不到您要查詢的影片。',
	p_no_access_event_not_found_desc: '抱歉，找不到您要查詢的活動。',
	p_no_access_nba_tv_title: '解鎖 NBA TV 以觀看：',
	p_no_access_nba_tv_desc: '觀看直播賽事，並隨選點播其他節目和經典賽事。',
	p_no_access_nba_tv_terms: '適用相關條款',
	p_no_access_nba_tv_geo_desc: '根據您目前的位置，您無法透過 NBA League Pass 和 NBA TV 觀看這場比賽。錄影賽事影片將在轉播後的 3 天，供 NBA League Pass 訂戶觀看。請洽詢您當地的電視或廣電業者，確認賽事播放的時間表。',
	p_no_access_nba_tv_not_found_desc: '抱歉，找不到您要查詢的頻道。',
	p_no_access_up_next: '緊接在後：',
	p_video_completed_title: '播放清單完成',
	p_video_completed_desc: '返回瀏覽，或查看您的下一個播放清單',
	p_video_share_to: '分享至：',
	p_video_more_to_watch: '更多觀看內容：',

	// Event
	p_event_section_title: '節目',
	p_event_playlist_title: '播放清單：',
	p_event_button_watch: '觀看',
	p_event_button_listen: '收聽',
	p_event_button_ticket: '票券',

	// notfound page
	notfound: '抱歉，找不到您要的頁面。',
	notfound_desc: '請檢查 URL 是否有誤。<br/>您也可以嘗試使用網站導覽或搜尋工具來尋找您要的內容。',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: '您的 NBA League Pass 帳戶已達串流上限。點選「繼續」以繼續在此裝置上收看。',
	modal_pcm_custom: '繼續',
	modal_pcm_close: '取消',
	modal_adobe_concurrency_header_title: '影片連線已中斷',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: '您的串流已關閉。可能的原因包括：已達同步串流的上限、網路連線中斷，或其他技術上的錯誤。請重新登入，並選取一個頻道再繼續。',
	modal_adobe_concurrency_close: '完成',
	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: '這部影片無法在您的裝置上播放。<a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>點此</a>取得相關協助。',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: '確定',

	// FreeSample
	freesample_notice_time: '剩餘時間',
	freesample_notice_title: '享受你的 {0} 分鐘權限',
	freesample_notice_desc: '訂閱完整的 League Pass 套餐，在 {0} 分鐘結束後繼續存取內容。',
	freesample_notice_subscribe_button: '訂閱',
	freesample_notice_cancel_button: '隨時取消',
	freesample_popup_title: '你的權限已結束',
	freesample_popup_subtitle: '訂閱 League Pass，觀看更多 NBA 精彩內容。',
	freesample_popup_link: '進一步瞭解',
	freesample_popup_get_minutes_button: '取得 {0}  分鐘',

	// Video list
	reg_required_desc: '您必須先登入才能查看此內容',
	favorite_teams_title: '最愛球隊',
	bookmarked_title: '已儲存',
	watch_history_title: '繼續觀看',
	game_schedule_title: '比賽賽程',
	recommended_title: '推薦',
	season_text: '賽季',

	// profile page
	section_tv_provider_title: '我的電視節目供應商',
	section_tv_provider_desc: '取得權限，觀看您電視節目供應商提供的直播賽事和串流內容。',
	section_tv_provider_faq: '電視節目供應商常見問題',
	section_tv_provider_sign_out: '登出',
	header_menu_account_my_account: '我的帳戶',
	header_menu_account_manage_account: '管理帳戶',
	header_menu_account_favorite_teams: '最愛球隊',
	header_menu_account_favorite_players: '我最愛的球員',
	header_menu_account_viewing_history: '觀看記錄',
};
